import React, { useEffect, useImperativeHandle, useState } from 'react'

import { IMaskInput } from 'react-imask'
import TextField from 'cityads-v3/components/TextField/TextField'

const IMaskInputWrapper = (props) => (
  <IMaskInput {...props} />
)

function IMaskInputComponent(props) {
  const { component: Component, inputRef, ...rest } = props

  const [inputNode, setInputNode] = useState(null)

  useImperativeHandle(inputRef, () => ({
    focus() {
      inputNode.focus()
    }
  }))

  useEffect(() => {
    if (inputNode && rest.autoFocus) {
      // On initial focus cursor gets positioned after the empty mask.
      // Refocus to trigger automatic cursor pos adjustment.
      inputNode.blur()
      const focusTimeout = setTimeout(() => inputNode.focus())
      return () => clearTimeout(focusTimeout)
    }
  }, [inputNode, rest.autoFocus])

  return <Component {...rest} inputRef={setInputNode} />
}

export default function MaskedTextField({ InputProps, ...rest }) {
  return (
    <TextField
      {...rest}
      slotProps={{
        input: {
          ...InputProps,
          inputComponent: IMaskInputComponent,
          inputProps: {
            ...InputProps?.inputProps,
            component: IMaskInputWrapper,
          },
        }
      }}
    />
  )
}
